export default __webpack_public_path__ + "static/media/Plus.44f86e1e.svg";